import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, BACKEND_URL } from "@/lib/api";
import Layout from "@/components/Layout";
import { Globe, Mail, ArrowLeft, MapPin } from "lucide-react";

export default function ExhibitorProfile() {
  const { id } = useParams();
  const [e, setE] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/exhibitors/${id}`).then(({ data }) => setE(data.exhibitor))
      .catch((er) => setErr(er?.response?.data?.detail || "Not found"));
    // Best-effort profile view tracking
    api.post(`/exhibitors/${id}/track-view`).catch(() => {});
  }, [id]);

  if (err) return (<Layout><section className="container-summit py-24"><p>{err}</p></section></Layout>);
  if (!e) return (<Layout><section className="container-summit py-24"><div className="overline">Loading…</div></section></Layout>);

  return (
    <Layout>
      <section className="container-summit py-12 md:py-16">
        <Link to="/directory" className="text-xs uppercase tracking-[0.18em] inline-flex items-center gap-2 text-zinc-500 hover:text-black">
          <ArrowLeft size={14} /> Back to directory
        </Link>
        <div className="mt-8 grid md:grid-cols-[200px_1fr] gap-8 items-start">
          <div className="h-28 flex items-start">
            {e.logo_file_id ? (
              <img src={`${BACKEND_URL}/api/files/${e.logo_file_id}`} alt={e.company_name} className="max-h-28 max-w-full object-contain" />
            ) : (
              <div className="h-28 w-full bg-zinc-100 flex items-center justify-center text-zinc-400 text-xs uppercase tracking-[0.18em]">No logo</div>
            )}
          </div>
          <div>
            <div className="overline mb-2">{e.industry}</div>
            <h1 className="text-3xl sm:text-5xl serif">{e.company_name}</h1>
            <div className="mt-4 flex flex-wrap gap-2">
              {(e.certifications || []).map((c) => <span key={c} className="pill">{c}</span>)}
              {e.booth_number && <span className="pill bg-black text-white border-black"><MapPin size={12} /> Booth {e.booth_number}</span>}
            </div>
            <p className="mt-6 text-zinc-700 leading-relaxed max-w-3xl">{e.description}</p>
          </div>
        </div>
        <div className="mt-12 grid md:grid-cols-2 gap-px bg-[hsl(var(--line))]">
          <div className="bg-white p-8">
            <div className="overline mb-3">Products & Services</div>
            <p className="text-zinc-700 leading-relaxed whitespace-pre-line">{e.products_services}</p>
          </div>
          <div className="bg-white p-8 grid gap-4">
            <div className="overline">Contact</div>
            <div className="text-sm">{e.primary_contact}{e.contact_title ? ` — ${e.contact_title}` : ""}</div>
            {e.website && <a href={e.website.startsWith("http") ? e.website : `https://${e.website}`} target="_blank" rel="noreferrer" className="text-sm inline-flex items-center gap-2 underline underline-offset-4"><Globe size={14} /> {e.website}</a>}
          </div>
        </div>
      </section>
    </Layout>
  );
}
